import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import shortid from 'shortid';
import { getFundRequest } from './actions';
import { findField } from '../actions/common';
import ModalUpdateFR from './ModalUpdateFR';
import TrackedField from '../common/TrackedField';
import { describeBeneficiaryObject } from '../Beneficiary/actions';

class FundRequestView extends React.Component {
    constructor() {
        super();
        this.state = {
            fundRequest: {},
            modalShownFR: false,
        };
        this.getFundRequest = getFundRequest.bind(this);
        this.layout = {};
        this.printColumn = this.printColumn.bind(this);
    }

    async componentWillMount() {
        // await this.props.describeBeneficiaryObject();
        // This layout is to configure what will be seen by user, it's mapped to salesforce Object
        this.layout = {
            frDetail: {
                0: ['Name', 'Year__c', 'Period__c', 'Variation__c', 'Current_FR__c'],
                1: ['FR_Status__c', 'Partner_Type__c', 'Partner_Subtype__c', 'Type__c', 'Mode_of_Payment__c'],
            },
            projectionDetails: {
                0: ['Projection_From__c',
                    // Rate_Secondary__c, 'Rate_Primary__c',
                    'Projected_No_of_Pri_Benes__c', 'Total_Pri_Receipts__c',
                    'Projection_Amount_Pri__c', 'Projection_Amount_PriF__c', '', '',
                    'Projected_No_of_Secondary_Benes__c', 'Total_Sec_Receipts__c',
                    'Projection_Amount_Sec__c', 'Projection_Amount_SecF__c', '', '',
                    'Projected_No_of_Post_Sec_Benes__c', 'Total_Post_Sec_Receipts__c', // 'Rate_Post_Sec__c',
                    'Projection_Amount_Post_Sec__c', 'Projection_Amount_Post_SecF__c', '',
                    'Total_Project_No_of_Benes__c',
                ],
                1: ['Projection_To__c',
                    // 'FR_Variation__c', 'Projection_Accuracy_P__c',
                    'Actual__c', 'Actual_No_of_Sec_Benes__c',
                    'Actual_No_of_Post_Sec_Benes__c', 'Total_No_of_Actual_Benes__c'],
            },
            primarySchool: {
                0: ['Request_Amount_Pri__c', 'Bank_Balance_Pri__c'],
                1: ['Disbursed_Amount_Pri__c', 'Approved_Amount_Pri__c', 'Available_amount_Pri__c'],
            },
            secondarySchool: {
                0: ['Request_Amount_Sec__c', 'Bank_Balance_Sec__c'],
                1: ['Disbursed_Amount_Sec__c', 'Approved_Amount_Sec__c', 'Available_amount_Sec__c'],
            },
            priSecSchool: {
                0: ['Request_Amount_Pri_Sec__c', 'Bank_Balance_Pri_Sec__c', 'Declared_Pri_Sec_Balance__c'],
                1: ['Disbursed_Amount_Pri_Sec__c', 'Approved_Amount_Pri_Sec__c', 'Available_amount_Pri_Sec__c'],
            },
            postSecSchool: {
                0: ['Request_Amount_Post_Sec__c', 'Bank_Balance_Post_Sec__c', 'Declared_Post_Sec_Balance__c'],
                1: ['Disbursed_Amount_Post_Sec__c', 'Approved_Amount_Post_Sec__c', 'Available_amount_Post_Sec__c'],
            },
            fundDetail: {
                0: ['Total_Request_Amount__c', 'CreatedDate'],
                1: ['Total_Disbursed_AmountF__c', 'Amount_Received_by_Beneficiary__c', 'LastModifiedDate'],
            },
        };
        await this.getFundRequest(this.props.match.params.id);
    }
componentDidMount() {
    console.log('componentDidMount', this.props.frObjectInfo.map(obj => obj.name).sort())
}
    // Printing the field list for view
    printColumn(section, colNo) {
        const { fundRequest } = this.state;
        return this.layout[section][colNo].map((val) => {
            if (val === '') return <div key={shortid.generate()} style={{ height: 30 }} />;

            const fieldInfo = findField(val, this.props.frObjectInfo);
            if (val === 'Declared_Pri_Sec_Balance__c') console.log(1, fieldInfo);
            if (val === 'Declared_Post_Sec_Balance__c') console.log(2, fieldInfo);

            if (fieldInfo.label === 'Variation Indicator (Sec)' || fieldInfo.label === 'Variation Indicator (Pri)' || fieldInfo.label === 'Variation Indicator (Post Sec)') return '';

            let fieldValue = null;
            if (fieldInfo.type === 'currency') fieldValue = `$ ${fundRequest[val] ? fundRequest[val].toLocaleString() : 0}`;
            else if (fieldInfo.type === 'datetime') fieldValue = moment(fundRequest[val]).format('DD-MMM-YYYY hh:mm a');
            else if (fieldInfo.type === 'date') fieldValue = moment(fundRequest[val]).format('DD-MMM-YYYY');
            else if (fieldInfo.type === 'boolean') fieldValue = <i className={`fa fa-${fundRequest[val] ? 'check' : 'time'} fa-2x`} />;
            else fieldValue = fundRequest[val];

            return (
                <div className="row item-printed" key={shortid.generate()}>
                    <p className="col-lg-6" style={{ textAlign: 'right' }}>{fieldInfo.label}</p>
                    <p className="col-lg-1">:</p>
                    <p className="col-lg-5">{fieldValue}</p>
                </div>
            );
        });
    }

    render() {
        const { fundRequest } = this.state;
        console.log(this.props.frObjectInfo.map(obj => obj.name).sort());
        // .filter((a, b) => {
        //     if (a > b) return 1;
        //     if (a < b) return -1;
        //     return 0;
        // })
        const buttons = [];
        if (fundRequest.Partner_Name__c !== undefined) {
            if (this.props.user.loggedInUser.AccountId !== fundRequest.Partner_Name__c) return <Redirect to="/portal/fund-request" />;
        }

        if (fundRequest.FR_Status__c === 'Planned' && fundRequest.Partner_Type__c === 'Disbursing Agency') {
            buttons.push(
                <button
                    type="button"
                    className="btn btn-info"
                    onClick={() => this.setState({ modalShownFR: true })}
                    key={shortid.generate()}
                >
                    <i className="fa fa-pencil" /> Edit
                </button>,
            );
        }
        return (
            <div className="row card">
                <div className="row">
                    <div className="col-lg-6 col-sm-12 col-xs-12">
                        <div className="btn-group" role="group" aria-label="...">
                            <button
                                type="button"
                                className="btn btn-default btn-fill"
                                onClick={() => {
                                    if (this.props.history.length <= 1) this.props.history.push('/portal/fund-request');
                                    else this.props.history.goBack();
                                }}
                            >
                                <i className="fa fa-arrow-left" /> Back
                            </button>
                            {buttons}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <p style={{ textAlign: 'center' }}>
                        {this.state.loading ? <i className="fa fa-3x fa-spinner fa-spin" /> : null}
                    </p>
                    <h4>Fund Request Detail</h4>
                    <hr />
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('frDetail', 0)}
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('frDetail', 1)}
                    </div>
                </div>
                <div className="row">
                    <h4>Projection Details</h4>
                    <hr />
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('projectionDetails', 0)}
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('projectionDetails', 1)}
                    </div>
                </div>
                <div className="row">
                    <h4>Primary School Fund Details</h4>
                    <hr />
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('primarySchool', 0)}
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('primarySchool', 1)}
                    </div>
                </div>
                <div className="row">
                    <h4>Secondary School Fund Details</h4>
                    <hr />
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('secondarySchool', 0)}
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('secondarySchool', 1)}
                    </div>
                </div>
                <div className="row">
                    <h4>Pri/Sec School Fund Details</h4>
                    <hr />
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('priSecSchool', 0)}
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('priSecSchool', 1)}
                    </div>
                </div>
                <div className="row">
                    <h4>Post/Sec School Fund Details</h4>
                    <hr />
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('postSecSchool', 0)}
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('postSecSchool', 1)}
                    </div>
                </div>
                <div className="row">
                    <h4>Fund Details</h4>
                    <hr />
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('fundDetail', 0)}
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                        {this.printColumn('fundDetail', 1)}
                    </div>
                </div>
                <div className="row">
                    <TrackedField
                        objectName="Fund_Request__c"
                        salesforceId={this.props.match.params.id}
                        hashToken={this.props.user.siteToken.hash}
                    />
                </div>
                <ModalUpdateFR
                    id={fundRequest.Id}
                    visible={this.state.modalShownFR}
                    hideModal={() => this.setState({ modalShownFR: false })}
                    afterSaveCallback={() => this.componentWillMount()}
                />
            </div>
        );
    }
}

FundRequestView.propTypes = {
    user: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    frObjectInfo: PropTypes.array.isRequired,
    describeBeneficiaryObject: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
        describeBeneficiaryObject,
    }, dispatch)
);

const mapStateToProps = state => {
    console.log(2, state)
    return {
        user: state.user,
        frObjectInfo: state.objectInfo.Fund_Request__c,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(FundRequestView);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/FundRequest/FundRequestView.js
// module id = 998
// module chunks = 0